export default __webpack_public_path__ + "static/assets/med_pill_square_flat_L1_solid_l_01_f.fbaaabc8.png";